// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"m5","controlPlay":"m6","controlElement":"m7","lowerControlWrapper":"m8","lowerControlIconWrapper":"m9","lowerControlIcon":"m-","show":"m_"};